import axios from '@/axios.js'

export default {
  fetchDataListReports ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-aqi')
        .then((response) => {
          commit('SET_REPORTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  filterReport ({ commit } , payload) {
    let formatted_start_date = ''
    let filterStartDate = ''
    let startTime = ''
    if(payload.filterStartDate){
      filterStartDate = new Date(payload.filterStartDate)
      if(payload.filterStartTime){
        startTime = payload.filterStartTime.split(":")
        filterStartDate.setHours( startTime[0], startTime[1] )
      }else{
        filterStartDate.setHours( 0, 0 )
      }
      formatted_start_date = filterStartDate.getFullYear() + '-'
        + (filterStartDate.getMonth() + 1) + '-'
        + filterStartDate.getDate() + ' '
        + filterStartDate.getHours() + ':'
        + filterStartDate.getMinutes() + ':'
        + filterStartDate.getSeconds()
    }

    let formatted_end_date = ''
    let filterEndDate = ''
    let endTime = ''
    if(payload.filterEndDate){
      filterEndDate = new Date(payload.filterEndDate)
      if(payload.filterEndTime){
        endTime = payload.filterEndTime.split(':')
        filterEndDate.setHours( endTime[0], endTime[1] )
      }else{
        filterEndDate.setHours( 0, 0 )
      }
      formatted_end_date = filterEndDate.getFullYear() + '-'
        + (filterEndDate.getMonth() + 1) + '-'
        + filterEndDate.getDate() + ' '
        + filterEndDate.getHours() + ':'
        + filterEndDate.getMinutes() + ':'
        + filterEndDate.getSeconds()
    }

    //หากเลือกวันเดียวกัน และไม่ได้เลือกเวลา
    if(payload.filterStartDate.toString() == payload.filterEndDate.toString() && payload.filterStartTime == '' && payload.filterEndTime == ''){
      formatted_end_date = ''
    }

    return new Promise((resolve, reject) => {
      axios.get('/get-list-aqi' , { params: {village_id: payload.filterMeasuringPoint , filter_start_date: formatted_start_date , filter_end_date: formatted_end_date } })
        .then((response) => {
          commit('SET_REPORTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error.response.data) })
    })
  },
  fetchDataListUsers ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-user')
        .then((response) => {
          commit('SET_USERS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addUser ({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios.post('/create-user', JSON.stringify(user), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          commit('ADD_USER', JSON.parse(response.config.data))
          const log = { 'log': 'เพิ่มผู้ดูแลระบบ' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error.response.data) })
    })
  },
  updateUser ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/edit-user/${item.id}`, JSON.stringify(item), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          commit('UPDATE_USER', JSON.parse(response.config.data))
          const log = { 'log': 'แก้ไขผู้ดูแลระบบ' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error.response.data) })
    })
  },
  removeUser ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post(`/delete-user/${itemId}`)
        .then((response) => {
          commit('REMOVE_USER', itemId)
          const log = { 'log': 'ลบผู้ดูแลระบบ' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListMeasuringPoints ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-government')
        .then((response) => {
          commit('SET_MEASURING_POINTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  addMeasuringPoint ({ commit }, measuring_point) {
    return new Promise((resolve, reject) => {
      axios.post('/create-government', JSON.stringify(measuring_point), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          commit('ADD_MEASURING_POINTS', JSON.parse(response.config.data))
          const log = { 'log': 'เพิ่มจุดตรวจวัด' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateMeasuringPoint ({ commit }, item) {
    return new Promise((resolve, reject) => {
      axios.post(`/edit-government/${item.id}`, JSON.stringify(item), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then((response) => {
          commit('UPDATE_MEASURING_POINTS', JSON.parse(response.config.data))
          const log = { 'log': 'แก้ไขจุดตรวจวัด' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  removeMeasuringPoint ({ commit }, itemId) {
    return new Promise((resolve, reject) => {
      axios.post(`/delete-government/${itemId}`)
        .then((response) => {
          commit('REMOVE_MEASURING_POINTS', itemId)
          const log = { 'log': 'ลบจุดตรวจวัด' }
          axios.post('/add-log', JSON.stringify(log), {
            headers: {
              'Content-Type': 'application/json'
            }
          })
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListSubDistricts ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-subdistrict')
        .then((response) => {
          commit('SET_SUB_DISTRICTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListVillages ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-all-village')
        .then((response) => {
          commit('SET_VILLAGES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  filterDataListVillages ({ commit } , payload) {
    const params = {
      subdistrict_id: payload.sub_district_id,
    };
    return new Promise((resolve, reject) => {
      axios.get('/get-list-village',{params})
        .then((response) => {
          // const data = response.data.data.filter(function (item) {
          //   return item.subdistrict_id === payload.sub_district_id
          // })
          commit('SET_VILLAGES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListUserLogs ({ commit }) {
    return new Promise((resolve, reject) => {
      axios.get('/get-list-log')
        .then((response) => {
          commit('SET_USER_LOGS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  changePassword ({ commit } , payload) {
    var data = {'old_password': payload.old_password, 'new_password': payload.new_password , 'confirm_password': payload.confirm_new_password}
    return new Promise((resolve, reject) => {
      axios.post('/change-password' ,JSON.stringify(data) , {
          headers: {
            'Content-Type': 'application/json'
          }
        })
        .then((response) => {
          if (response.data === null){
            resolve('No Data')
          } else {
            resolve(response.data)
          }
        })
        .catch((error) => { reject(error.response.data) })
    })
  },
  forgotPassword ({ commit } , email) {
    return new Promise((resolve, reject) => {
      axios.get('/forget-password' ,{ params : email })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => {
          reject(error.response.data) })
    })
  },
  resetPassword ({ commit } , payload) {
    var data = {'password': payload.password , 'confirm_password': payload.confirm_password}
    return new Promise((resolve, reject) => {
      axios.post('/reset-password' ,JSON.stringify(data) , {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': payload.token
        }
      })
        .then((response) => {
          resolve(response.data)
        })
        .catch((error) => { reject(error.response.data) })
    })
  }
}
